/**
 * Wraps a potentially undefined method to return a promise
 *
 * @returns a promise that resolves to null if the method is not defined
 */
export function callPromiseSafely<T, A extends unknown[]>(
  method?: ((...args: A) => Promise<T>) | null,
  ...args: A
): Promise<T | null> {
  return method ? method(...args) : Promise.resolve(null);
}
